var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCaptures = function SvgCaptures(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.049 7.157-.913-3.196a1.152 1.152 0 0 0-1.108-.835H5.72c-.515 0-.967.341-1.108.836L3.7 7.156M6.846 7.513c-.149-.193-.357-.356-.601-.356H3.699v3.167c0 .636.516 1.152 1.152 1.152h6.046c.636 0 1.152-.516 1.152-1.152V7.157H9.503c-.244 0-.452.163-.6.356a1.294 1.294 0 0 1-2.057 0Z",
    stroke: "#B8B8B8",
    strokeWidth: 0.696,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgCaptures;